// Which Filters-panel rows reach a server-mode grid's `filter` param (A794, Aaron
// 2026-10-13: "QA filters").
//
// One rule for every serializer — the list grid (DataGrid.tsx), the detail-tab grid
// (DataGridPremium.tsx), Inventory Demand's grid and the CSV / Print export (useGridExport):
//
//   - a row with a value is applied;
//   - MUI's VALUELESS operators ("is empty", "is not empty") are applied — they used to be
//     dropped for having no value, so the panel and the header icon showed a filter the
//     route never received and the rows did not change. The generic route
//     (sqlalchemy-filters, app/crud.py) applies them as IS NULL / IS NOT NULL, and
//     applyClientGridParams (clientGridParams.ts) as blank / not blank;
//   - "is any of" with nothing picked yet is NOT applied — it used to go out as `IN ()`
//     and empty the list while the user was still choosing;
//   - the legacy "!=" with no value still goes (unchanged).
import type { GridFilterItem } from "@mui/x-data-grid-pro";

/** MUI operators that take no value. */
export const VALUELESS_FILTER_OPERATORS = new Set(["isEmpty", "isNotEmpty"]);

/** Does this Filters-panel row narrow the grid (and so go to the route)? */
export function isAppliedFilterItem(item: Pick<GridFilterItem, "operator" | "value">): boolean {
  if (VALUELESS_FILTER_OPERATORS.has(String(item.operator))) return true;
  if (item.operator === "!=") return true;
  const v = item.value;
  if (v === undefined || v === null || v === "") return false;
  if (Array.isArray(v) && v.length === 0) return false;
  return true;
}
